export default {
  title: 'Muokkaa tilausta',
  product_info: {
    earn_points: 'Ansaitse {{points}} pistettä',
  },
};
